/**
 * @generated SignedSource<<59b899e8bd380d346b867003c71f8738>>
 * @relayHash 83ab3e1125e283dbf6e6390477296f1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cfb52c9efc9b3c41fe1bcd31142566157d9f0551b2c0e16e355846a12a24f724

import type { ConcreteRequest } from 'relay-runtime';
export type SettingsNavigationCustomisationInput = {
  entityAri: string;
  ownerAri?: string | null;
  properties?: ReadonlyArray<SettingsDisplayPropertyInput | null> | null;
  sidebar?: ReadonlyArray<SettingsMenuItemInput | null> | null;
};
export type SettingsDisplayPropertyInput = {
  key: string;
  value: string;
};
export type SettingsMenuItemInput = {
  menuId: string;
  visible: boolean;
};
export type useUpdateNestedItemOrderMutation$variables = {
  input: SettingsNavigationCustomisationInput;
};
export type useUpdateNestedItemOrderMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null;
        readonly visible: boolean | null;
      } | null> | null;
    } | null;
  } | null;
};
export type useUpdateNestedItemOrderMutation = {
  response: useUpdateNestedItemOrderMutation$data;
  variables: useUpdateNestedItemOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsMenuItem",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "menuId"
        },
        {
          "kind": "ScalarField",
          "name": "visible"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUpdateNestedItemOrderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateNestedItemOrderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cfb52c9efc9b3c41fe1bcd31142566157d9f0551b2c0e16e355846a12a24f724",
    "metadata": {},
    "name": "useUpdateNestedItemOrderMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "944a7b0270efd174321b0b4015219ece";

export default node;
